import { Calendar, Channel, DocumentText, Home, IconProps, Multimedia, Resources, Video, Yoga } from 'grommet-icons';

export type TalonIconProps = IconProps & {
  type: 'media' | 'post' | 'prePro' | 'production' | 'report' | 'resources' | 'session' | 'sessionActivity';
};

export const TalonIcon = ({ type, ...props }: TalonIconProps) => {
  switch (type) {
    case 'media':
      return <Multimedia {...props} />;
    case 'post':
      return <Home {...props} />;
    case 'prePro':
      return <Video {...props} />;
    case 'production':
      return <Channel {...props} />;
    case 'report':
      return <Calendar {...props} />;
    case 'resources':
      return <Yoga {...props} />;
    case 'session':
      return <DocumentText {...props} />;
    case 'sessionActivity':
      return <Resources {...props} />;
    default:
      return <></>;
  }
};
